<div *ngIf="show">
  <span class="color-error font-small">
    Please review the form and ensure all required fields are filled in.
  </span>
</div>
